import React, { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/content";
import { eyebrow, h2, section, shell } from "../utils/styles";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section id="faq" className={shell} data-id="element-46" data-mp="1gauql8kyluhv">
      <div className={`${section} grid gap-2.5 border-t border-[#30382a] sm:grid-cols-[0.75fr_1.25fr] sm:gap-[60px]`} data-id="element-47" data-mp="2e0ps7rlx2rdp">
        <div data-id="element-48" data-mp="292o7714xkhzl">
          <p className={eyebrow} data-id="element-49" data-mp="2924o3h3jnnjz">Preguntas frecuentes</p>
          <h2 className={h2} data-id="element-50" data-mp="241gzt36p9ktg">Lo que más me preguntan</h2>
        </div>

        <div data-id="element-51" data-mp="1z374mskz6k7u">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="border-b border-line-soft" data-id="element-52" data-mp="smv3qjqrqo8k" data-mpi={i}>
                <h3 data-id="element-53" data-mp="sl0h90zumo2d">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-[22px] py-[21px] text-left text-[13px] leading-normal text-fg" data-id="element-54" data-mp="no0aenv6dha7">
                    {f.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-lime transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-55" data-mp="kiuubu14tlja" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-56" data-mp="bk9g2b2p0sob">
                  {isOpen && <motion.div id={`faq-${i}`} role="region" initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={reduce ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-57" data-mp="3t07um9gbvq6v">
                      <p className="mb-[22px] pr-6 text-xs leading-[1.75] text-muted" data-id="element-58" data-mp="1pp33i6vmn8ag">
                        {f.a}
                        {f.link && <>
                            {" "}
                            <a href={f.link.href} target="_blank" rel="noopener noreferrer" className="text-lime underline underline-offset-4" data-id="element-59" data-mp="1ftj95owpohnt">
                              {f.link.label}
                            </a>
                            .
                          </>}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}